import type * as React from 'react'

export interface BannerCandidate {
  /** Still resolving — blocks lower-priority candidates so a lower banner never flashes first. */
  isPending: boolean
  isEligible: boolean
  render: () => React.ReactNode
}

/** The highest-priority eligible candidate, or null. A pending candidate blocks everything below it. */
export function pickFirstEligible<T extends BannerCandidate>(candidates: readonly T[]): T | null {
  for (const candidate of candidates) {
    if (candidate.isPending) {
      return null
    }
    if (candidate.isEligible) {
      return candidate
    }
  }
  return null
}
